import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Offcanvas,
  Modal,
} from "react-bootstrap";
import AccountImage from "../../../style/Img/Account/DefaultImage.png";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";

function ListaImpiegati() {
  let history = useHistory();

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  let [id, setId] = useState("");

  const [valore, setValore] = useState(0);

  const eliminaImpiegato = () => {
    console.log(id);
    const data = { id: id };
    axios
      .post(
        `https://website-8bit-motors.herokuapp.com/amministratore/rimuoviImpiegato`,
        data
      )
      .then((response) => {
        if (response.data.error) {
          alert(response.data.error);
        } else {
          setShowModal(false);
          history.go(0);
        }
      });
  };

  const [listaImpiegati, setListaImpiegati] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://website-8bit-motors.herokuapp.com/amministratore/ottieniImpiegati"
      )
      .then(function (response) {
        setListaImpiegati(response.data);
      });
  }, []);

  return (
    <>
      <Container fluid className="text-center">
        {/* SEZIONE BANNER */}
        <Container
          fluid
          className="head-banner text-white text-center"
          id="banner_accesso"
        >
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>

        <Container>
          <Fade left>
            <h2 align="center" className="mt-2">
              <strong>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-person-lines-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" />
                </svg>{" "}
                Lista Impiegati{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-person-lines-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" />
                </svg>
              </strong>
            </h2>
          </Fade>

          <Zoom>
            <Container fluid>
              <Row>
                {listaImpiegati.map((value, key) => {
                  return (
                    <>
                      <Col className="col-lg-4">
                        <Card
                          key={key}
                          className="mt-2"
                          style={{ width: "18rem" }}
                        >
                          <Card.Img variant="top" src={AccountImage} />
                          <Card.Body>
                            <Card.Title>
                              {value.nome} {value.cognome}
                            </Card.Title>
                            <Card.Text>
                              <h5>Ruolo:</h5>
                              <p>{value.tipo}</p>
                            </Card.Text>
                            <Button
                              onClick={() => {
                                setShowModal(true);
                                setValore(key);
                                setId(listaImpiegati[key].id);
                              }}
                              variant="danger"
                            >
                              Rimuovi Impiegato
                            </Button>
                            <Button
                              variant="info"
                              className="mt-2"
                              onClick={() => {
                                setShow(true);
                                setValore(key);
                              }}
                            >
                              Maggiori Informazioni
                            </Button>
                          </Card.Body>
                        </Card>
                      </Col>

                      <Offcanvas show={show} onHide={handleClose}>
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            {listaImpiegati[valore].nome}{" "}
                            {listaImpiegati[valore].cognome}
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <h2>Dati Personali</h2>
                          <br />
                          <h3>Email:</h3>
                          <p>{listaImpiegati[valore].email}</p>
                          <h3>Data di Nascita:</h3>
                          <p>{listaImpiegati[valore].dataNascita}</p>
                          <h3>Regione:</h3>
                          <p>{listaImpiegati[valore].regione}</p>
                          <h3>Provincia:</h3>
                          <p>{listaImpiegati[valore].provincia}</p>
                          <h3>CAP:</h3>
                          <p>{listaImpiegati[valore].CAP}</p>
                          <h3>Indirizzo:</h3>
                          <p>{listaImpiegati[valore].indirizzo}</p>
                          <h3>Telefono:</h3>
                          <p>{listaImpiegati[valore].telefono}</p>

                          <h2>Dati Patente</h2>
                          <br />
                          <h3>Codice Patente:</h3>
                          <p>{listaImpiegati[valore].codicePatente}</p>
                          <h3>Nominativo:</h3>
                          <p>{listaImpiegati[valore].nominativo}</p>
                          <h3>Data di Rilascio:</h3>
                          <p>{listaImpiegati[valore].dataRilascio}</p>
                          <h3>Data di Scadenza:</h3>
                          <p>{listaImpiegati[valore].scadenzaPatente}</p>

                          <h2>Estremi di Fatturazione</h2>
                          <br />
                          <h3>Nome Intestatario:</h3>
                          <p>{listaImpiegati[valore].scadenzaCarta}</p>
                          <h3>Codice Carta:</h3>
                          <p>{listaImpiegati[valore].codiceCarta}</p>
                        </Offcanvas.Body>
                      </Offcanvas>

                      <Modal show={showModal} onHide={handleCloseModal}>
                        <Modal.Header closeButton>
                          <Modal.Title>
                            Licenzia {listaImpiegati[valore].nome}{" "}
                            {listaImpiegati[valore].cognome}
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          Sei sicuro di volere licenziare{" "}
                          {listaImpiegati[valore].nome}{" "}
                          {listaImpiegati[valore].cognome}? QUESTA AZIONE È
                          IRREVERSIBILE!
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="success" onClick={handleClose}>
                            Annulla
                          </Button>
                          <Button variant="danger" onClick={eliminaImpiegato}>
                            Licenzia.
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  );
                })}
              </Row>
            </Container>
          </Zoom>
        </Container>

        <Button
          variant="dark"
          className="mt-3"
          onClick={() => {
            history.push("/amministratore/aggiungiImpiegato");
          }}
        >
          Aggiungi Impiegato
        </Button>

        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </Container>
    </>
  );
}

export default ListaImpiegati;
